import { lazy } from 'react';

// project imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';
import OAuthCallback from 'views/account/oauthcallback';


// login routing
const AuthLogin = Loadable(lazy(() => import('views/pages/authentication/Login')));
const AuthRegister = Loadable(lazy(() => import('views/pages/authentication/Register')));
const AuthForgotPassword = Loadable(lazy(() => import('views/pages/authentication/ForgotPassword')));


// const AuthResetPassword = Loadable(lazy(() => import('views/pages/authentication/ResetPassword')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
    path: '/',
    element: (
        <NavMotion>
            <GuestGuard>
                <MinimalLayout />
            </GuestGuard>
        </NavMotion>
    ),
    children: [
        {
            path: '/login',
            element: <AuthLogin />
        },
        {
            path: '/register',
            element: <AuthRegister />
        },
        // we allow reset password even if you are logged in !
        // {
        //     path: '/reset-password',
        //     element: <AuthResetPassword />
        // },
        {
            path: '/forgot-password',
            element: <AuthForgotPassword />
        },
        {
            path: '/auth/callback',
            element: <OAuthCallback />
        }

    ]
};

export default LoginRoutes;
